import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import { CustomBadge } from "../../shared/utils/Badge";
import { Constants } from "../../shared/constants";

const SchedulesTable = () => {
    const scheduleRows = [
        { id: 1, category: "Development Test", course: "C++ Programming", batch: "A", fromDate: "25-01-2025", toDate: "25-02-2025", status: "Ongoing" },
        { id: 2, category: "Mathematics", course: "Differential Equation", batch: "B", fromDate: "12-03-2025", toDate: "25-03-2025", status: "Ongoing" },
        { id: 3, category: "Social Science", course: "History", batch: "C", fromDate: "01-04-2025", toDate: "02-05-2025", status: "Completed" },
        { id: 4, category: "Development Test", course: "C++ Programming", batch: "A", fromDate: "25-01-2025", toDate: "25-03-2025", status: "Ongoing" },
        { id: 5, category: "Mathematics", course: "Differential Equation", batch: "B", fromDate: "12-02-2025", toDate: "25-03-2025", status: "Ongoing" },
        { id: 6, category: "Social Science", course: "History", batch: "C", fromDate: "01-01-2025", toDate: "02-02-2025", status: "Completed" },
        { id: 7, category: "Social Science", course: "History", batch: "C", fromDate: "01-01-2025", toDate: "02-02-2025", status: "Completed" },
        { id: 8, category: "Social Science", course: "History", batch: "C", fromDate: "01-01-2025", toDate: "02-02-2025", status: "Completed" },
        { id: 9, category: "Social Science", course: "History", batch: "C", fromDate: "01-01-2025", toDate: "02-02-2025", status: "Completed" },
        { id: 10, category: "Social Science", course: "History", batch: "C", fromDate: "01-01-2025", toDate: "02-02-2025", status: "Completed" },
        { id: 11, category: "Social Science", course: "History", batch: "C", fromDate: "01-01-2025", toDate: "02-02-2025", status: "Completed" },
        { id: 12, category: "Social Science", course: "History", batch: "C", fromDate: "01-01-2025", toDate: "02-02-2025", status: "Completed" },
    ];

    const scheduleColumns = [
        {
            field: "category", headerName: "Course Category", flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2}>{params.value}</Typography>,

        },
        {
            field: "course", headerName: "Course Name", flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "batch", headerName: "Batch", flex: 0.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "fromDate", headerName: "From Date", flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "toDate", headerName: "To Date", flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => (
                <Typography variant="body2" style={{ color: params.value === "Completed" ? "#149700" : "#EC8E01" }}>
                    {params.value}
                </Typography>
            ),
        },
        {
            field: "attendance",
            headerName: "Attendance",
            flex: 0.5,
            renderCell: () => (
                <CustomBadge icon={<img src={Constants.customIcon.ViewAttendace} alt="view Attendace icon" width={"25px"}/>} bgcolor={"#EFF3FF"} />
            ),
        },
        {
            field: "uploadPhoto",
            headerName: "Upload Photo",
            flex: 0.5,
            renderCell: () => (
                <CustomBadge icon={<img src={Constants.customIcon.UploadImg} alt="upload icon" width={"25px"}/>} bgcolor={"#EFF3FF"} />
            ),
        },
    ];

    return (
        <Box>
            <DataGrid
                rows={scheduleRows}
                columns={scheduleColumns}
                disableRowSelectionOnClick
                autoHeight
                getRowHeight={() => "auto"}
            />
        </Box>
    );
}

export default SchedulesTable;
